/*
 * Licensed to Elasticsearch B.V. under one or more contributor
 * license agreements. See the NOTICE file distributed with
 * this work for additional information regarding copyright
 * ownership. Elasticsearch B.V. licenses this file to you under
 * the Apache License, Version 2.0 (the "License"); you may
 * not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import React from 'react';
import PropTypes from "prop-types";
import classNames from 'classnames';
var responsiveSizesToClassNameMap = {
  xs: 'eui-hideFor--xs',
  s: 'eui-hideFor--s',
  m: 'eui-hideFor--m',
  l: 'eui-hideFor--l',
  xl: 'eui-hideFor--xl'
};
export var EuiHideFor = ({
  children,
  sizes
}) => {
  const utilityClasses = sizes.map(function (item) {
    return responsiveSizesToClassNameMap[item];
  });

  if (React.isValidElement(children)) {
    return <React.Fragment>
        {React.Children.map(children, child => React.cloneElement(child, {
        className: classNames(child.props.className, utilityClasses)
      }))}
      </React.Fragment>;
  } else {
    return <span className={classNames(utilityClasses)}>{children}</span>;
  }
};
EuiHideFor.propTypes = {
  children: PropTypes.node,

  /**
     * List of all the responsive sizes to show the children for.
     * Options are `'xs' | 's' | 'm' | 'l' | 'xl'`
     */
  sizes: PropTypes.arrayOf(PropTypes.oneOf(["xs", "s", "m", "l", "xl"]).isRequired).isRequired
};

try {
  // @ts-ignore
  EuiHideFor.displayName = "EuiHideFor"; // @ts-ignore

  EuiHideFor.__docgenInfo = {
    "description": "",
    "displayName": "EuiHideFor",
    "props": {
      "sizes": {
        "defaultValue": null,
        "description": "List of all the responsive sizes to show the children for.\nOptions are `'xs' | 's' | 'm' | 'l' | 'xl'`",
        "name": "sizes",
        "required": true,
        "type": {
          "name": "EuiHideForBreakpoints[]"
        }
      }
    }
  }; // @ts-ignore

  if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["src/components/responsive/hide_for.tsx#EuiHideFor"] = {
      docgenInfo: EuiHideFor.__docgenInfo,
      name: "EuiHideFor",
      path: "src/components/responsive/hide_for.tsx#EuiHideFor"
    };
} catch (__react_docgen_typescript_loader_error) {}